import _defineProperty from "@babel/runtime/helpers/defineProperty";
export const CANVAS_EFFECT_READY_EVENT = 'canvas-effect-ready';
export const CANVAS_EFFECT_PLAY_EVENT = 'canvas-effect-play';
export const CANVAS_EFFECT_STOP_EVENT = 'canvas-effect-stop';
export const CANVAS_SOURCE_UPDATE_EVENT = 'canvas-source-update';
export const CANVAS_TARGET_RESIZE_EVENT = 'canvas-target-resize';
function wixMediaCanvasFactory(services, contextWindow) {
  var _WixMediaCanvas;
  return _WixMediaCanvas = class WixMediaCanvas extends contextWindow.HTMLElement {
    constructor() {
      super();
      _defineProperty(this, "source", void 0);
      _defineProperty(this, "loadEventName", void 0);
      _defineProperty(this, "state", void 0);
      _defineProperty(this, "loadEventHandler", void 0);
      this.source = null;
      this.loadEventName = 'load';
      this.state = {
        hasContext: false,
        isPosterRemoved: false,
        intersectionChecked: false
      };
      this.loadEventHandler = this._loadEventHandler.bind(this);
    }
    connectedCallback() {
      services.getPageReady().then(() => this.ready());
    }
    disconnectedCallback() {
      this._clear();
    }
    attributeChangedCallback(name, _old, value) {
      if (name === 'data-has-animation') {
        if (value === 'true') {
          this.observeResize();
          this.observeIntersect();
        } else {
          this._clear();
        }
      }
    }
    observeIntersect() {
      var _services$intersectio;
      (_services$intersectio = services.intersectionService) == null || _services$intersectio.observe(this);
    }
    unobserveIntersect() {
      var _services$intersectio2;
      (_services$intersectio2 = services.intersectionService) == null || _services$intersectio2.unobserve(this);
    }
    observeResize() {
      var _services$resizeServi;
      (_services$resizeServi = services.resizeService) == null || _services$resizeServi.observe(this);
    }
    unobserveResize() {
      var _services$resizeServi2;
      (_services$resizeServi2 = services.resizeService) == null || _services$resizeServi2.unobserve(this);
    }
    ready() {
      this._dispatchReady();
    }
    show() {
      const hasContext = services.contextManager.add(this);
      this.state.hasContext = hasContext;
      if (!hasContext) {
        if (this.state.isPosterRemoved) {
          this._showPoster();
        }
      } else {
        if (this.source instanceof HTMLVideoElement) {
          if (!this.state.isPosterRemoved) {
            // video is autoplaying, we need to reset it
            this.source.currentTime = 0;
            this.dataset.showCanvas = '';
            this.state.isPosterRemoved = true;
          }
        }
        this._dispatchPlay();
        this._observeSourceUpdate();
      }
    }
    hide() {
      if (!this.state.intersectionChecked) {
        this.state.intersectionChecked = true;
      }
      if (this.state.hasContext) {
        services.contextManager.remove(this);
        this.state.hasContext = false;
        // TODO: we need to handle case when source changes while hidden
        this._unobserveSourceUpdate();
      }
      this._dispatchStop();
    }
    resize(width, height) {
      if (this.state.hasContext) {
        this._dispatchResizeTarget(width, height);
      }
    }
    get target() {
      return this.querySelector('canvas');
    }
    _clear() {
      services.contextManager.remove(this);
      this.state.hasContext = false;
      this._unobserveSourceUpdate();
      this.unobserveIntersect();
      this.unobserveResize();
    }
    _observeSourceUpdate() {
      if (this.source) {
        this.source.addEventListener(this.loadEventName, this.loadEventHandler);
      }
    }
    _unobserveSourceUpdate() {
      if (this.source) {
        this.source.removeEventListener(this.loadEventName, this.loadEventHandler);
      }
    }
    _loadEventHandler() {
      this._dispatchUpdateSource();
    }
    _showPoster() {
      this.state.isPosterRemoved = false;
      delete this.dataset.showCanvas;
    }
    _dispatchReady() {
      const video = this.querySelector('video');
      const image = this.querySelector('img');
      this.source = video || image || null;
      if (video) {
        this.loadEventName = 'loadeddata';
      }
      this._dispatchEvent(CANVAS_EFFECT_READY_EVENT);
    }
    _dispatchPlay() {
      let reveal = false;
      if (!this.state.intersectionChecked) {
        this.state.intersectionChecked = true;
        reveal = true;
      }
      this._dispatchEvent(CANVAS_EFFECT_PLAY_EVENT, {
        reveal
      });
    }
    _dispatchStop() {
      this._dispatchEvent(CANVAS_EFFECT_STOP_EVENT);
    }
    _dispatchUpdateSource() {
      this._dispatchEvent(CANVAS_SOURCE_UPDATE_EVENT);
    }
    _dispatchResizeTarget(width, height) {
      this._dispatchEvent(CANVAS_TARGET_RESIZE_EVENT, {
        width,
        height
      });
    }
    _dispatchEvent(eventName, detail) {
      const canvasEvent = new CustomEvent(eventName, {
        bubbles: true,
        detail
      });
      this.dispatchEvent(canvasEvent);
    }
  }, _defineProperty(_WixMediaCanvas, "observedAttributes", ['data-has-animation']), _WixMediaCanvas;
}
export default wixMediaCanvasFactory;
//# sourceMappingURL=WixMediaCanvas.js.map